// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--2AF9X","spinner":"styles-module--spinner--wOvL8","rotate":"styles-module--rotate--3jQVh","label":"styles-module--label--1cLnV"};